/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CriteriaForLocationInput
 */
export interface CriteriaForLocationInput {
    /**
     * 
     * @type {string}
     * @memberof CriteriaForLocationInput
     */
    airportCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CriteriaForLocationInput
     */
    cityCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CriteriaForLocationInput
     */
    countryCode?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CriteriaForLocationInput
     */
    exclude?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CriteriaForLocationInput
     */
    isInboundArrival?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CriteriaForLocationInput
     */
    isInboundDeparture?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CriteriaForLocationInput
     */
    isOutboundArrival?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CriteriaForLocationInput
     */
    isOutboundDeparture?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CriteriaForLocationInput
     */
    regionCode?: string | null;
}

export function CriteriaForLocationInputFromJSON(json: any): CriteriaForLocationInput {
    return CriteriaForLocationInputFromJSONTyped(json, false);
}

export function CriteriaForLocationInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): CriteriaForLocationInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'airportCode': !exists(json, 'airportCode') ? undefined : json['airportCode'],
        'cityCode': !exists(json, 'cityCode') ? undefined : json['cityCode'],
        'countryCode': !exists(json, 'countryCode') ? undefined : json['countryCode'],
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
        'isInboundArrival': !exists(json, 'isInboundArrival') ? undefined : json['isInboundArrival'],
        'isInboundDeparture': !exists(json, 'isInboundDeparture') ? undefined : json['isInboundDeparture'],
        'isOutboundArrival': !exists(json, 'isOutboundArrival') ? undefined : json['isOutboundArrival'],
        'isOutboundDeparture': !exists(json, 'isOutboundDeparture') ? undefined : json['isOutboundDeparture'],
        'regionCode': !exists(json, 'regionCode') ? undefined : json['regionCode'],
    };
}

export function CriteriaForLocationInputToJSON(value?: CriteriaForLocationInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'airportCode': value.airportCode,
        'cityCode': value.cityCode,
        'countryCode': value.countryCode,
        'exclude': value.exclude,
        'isInboundArrival': value.isInboundArrival,
        'isInboundDeparture': value.isInboundDeparture,
        'isOutboundArrival': value.isOutboundArrival,
        'isOutboundDeparture': value.isOutboundDeparture,
        'regionCode': value.regionCode,
    };
}


